var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConfirmDelete(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 17.75A8.75 8.75 0 109 .25a8.75 8.75 0 000 17.5zm-.73-7.292V4.625h1.46v5.833H8.27zm0 1.459v1.458h1.46v-1.458H8.27z",
    fill: "#F74F4F"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAxOCAxOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik05IDE3Ljc1QzEzLjgzMjUgMTcuNzUgMTcuNzUgMTMuODMyNSAxNy43NSA5QzE3Ljc1IDQuMTY3NTEgMTMuODMyNSAwLjI1IDkgMC4yNUM0LjE2NzUxIDAuMjUgMC4yNSA0LjE2NzUxIDAuMjUgOUMwLjI1IDEzLjgzMjUgNC4xNjc1MSAxNy43NSA5IDE3Ljc1Wk04LjI3MDg0IDEwLjQ1ODNMOC4yNzA4NCA0LjYyNUg5LjcyOTE3VjEwLjQ1ODNIOC4yNzA4NFpNOC4yNzA4NCAxMS45MTY3VjEzLjM3NUg5LjcyOTE3VjExLjkxNjdIOC4yNzA4NFoiIGZpbGw9IiNGNzRGNEYiLz4KPC9zdmc+Cg==";
export { SvgConfirmDelete as ReactComponent };